const DownloadFile = async (urlFile, name) => {
    try {
        const response = await fetch(urlFile);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    } catch (error) {
        console.error('Error al descargar el archivo:', error);
    }
}

export default DownloadFile;